export const isPageReload = (urlSnippet = "") => {
  try {
    if (typeof window !== "undefined" && window.performance) {
      const navEntries = window.performance.getEntriesByType("navigation");
      if (navEntries && navEntries.length > 0) {
        const nav = navEntries[0];
        const isReload = nav.type === "reload";
        if (isReload) {
          if (urlSnippet && nav.name && !nav.name.toLowerCase().includes(urlSnippet.toLowerCase())) {
            return false;
          }
          return true;
        }
        return false;
      }
      if (window.performance.navigation) {
        return window.performance.navigation.type === 1;
      }
    }
  } catch (e) {
    console.error(e);
  }
  return false;
};

export const checkIsReturning = (ticketKey, navigationType, urlSnippet = "") => {
  const isReload = isPageReload(urlSnippet);
  return !isReload && navigationType === "POP" && sessionStorage.getItem(ticketKey) === "true";
};

export const setReturnTicket = (ticketKey) => {
  try {
    sessionStorage.setItem(ticketKey, "true");
  } catch (e) {
    console.error(e);
  }
};

export const consumeReturnTicket = (ticketKey) => {
  try {
    sessionStorage.removeItem(ticketKey);
  } catch (e) {
    console.error(e);
  }
};
